// Updated Navbar without gold logic
import React, { useRef, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../image/psf logo 4.png";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../Redux/common/action";

function Navbar() {
  const wrapperRef = useRef(null);
  const selectorRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const wrapper = wrapperRef.current;
    const selector = selectorRef.current;
    if (!wrapper || !selector) return;

    const items = wrapper.querySelectorAll("li.nav-item");
    const updateSelector = (el) => {
      const rect = el.getBoundingClientRect();
      const parentRect = wrapper.getBoundingClientRect();
      selector.style.width = `${rect.width}px`;
      selector.style.height = `${rect.height}px`;
      selector.style.transform = `translate(${rect.left - parentRect.left}px, ${rect.top - parentRect.top}px)`;
    };

    const currentItem = Array.from(items).find((li) => {
      const link = li.querySelector("a");
      return link?.getAttribute("href") === location.pathname;
    });

    items.forEach((item) => item.classList.remove("active"));
    if (currentItem) {
      currentItem.classList.add("active");
      updateSelector(currentItem);
    }

    const resizeHandler = () => {
      const activeItem = wrapper.querySelector("li.nav-item.active");
      if (activeItem) updateSelector(activeItem);
    };

    window.addEventListener("resize", resizeHandler);
    return () => window.removeEventListener("resize", resizeHandler);
  }, [location.pathname]);
const dispatch = useDispatch();
  const router = useNavigate();

  const [value, setValue] = useState("");
  const [valuevendor, setValuevendor] = useState("");
  const [valuesetUserDeatils, setUserDeatils] = useState({});

  const chooseState = (event) => {
    const state = event.target.value;
    dispatch(allapiAction.gethomePro({ state }));
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const tokenUser = localStorage.getItem("access_token");
      const tokenVendor = localStorage.getItem("access_token_vendor");
      const userDetails = localStorage.getItem("access_user");

      setValue(tokenUser || "");
      setValuevendor(tokenVendor || "");

      try {
        setUserDeatils(userDetails ? JSON.parse(userDetails) : {});
      } catch {
        setUserDeatils({});
      }
    }
  }, []);

  const isUserLoggedIn = Boolean(value);
  const isVendorLoggedIn = Boolean(valuevendor);

  const navLinks = [
    ["Home", "/", "fas fa-leaf"],
    ["Products", "/products", "fas fa-leaf"],
    ["Latest Products", "/latestproducts", "fas fa-leaf"],
     ["Become a Distributor", "/login", "fas fa-leaf"],
    // 👇 LOGIN condition
    isUserLoggedIn
      ? [
          valuesetUserDeatils?.fullName || "My Account",
          "/accounts",
          "fas fa-user",
        ]
      : !isVendorLoggedIn
      ? ["Login", "/login", "fas fa-leaf"]
      : null,
    // 👇 REGISTER condition (hide when logged in)
    !(isUserLoggedIn || isVendorLoggedIn)
      ? ["Register", "/register", "fas fa-leaf"]
      : null,
    ["", "/cart", "fas fa-shopping-cart"],
  ].filter(Boolean);
  return (
    <div className="navbar-new-mk">
      <nav className="navbar navbar-expand-lg navbar-mainbg three-d-nav position-fixed w-100  px-2" style={{ zIndex: 1000 }}>
        <div className="container-fluid py-2 py-lg-0">
          <div className="d-flex align-items-center">
            <Link className="navbar-brand d-flex align-items-center mx-auto" to="/">
              <img src={Logo} alt="logo" className="nav-logo me-2 w-100" />
            </Link>
          </div>

          <button className="navbar-toggler end-0 me-1" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
            <i className="fas fa-bars text-white"></i>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto align-items-center nav-wrapper" ref={wrapperRef}>
              <div className="hori-selector" ref={selectorRef}>
                <div className="top-right-circle"></div>
              </div>

              {navLinks.map(([name, path, icon]) => (
                <li key={path} className={`nav-item ${location.pathname === path ? "active" : ""}`}>
                  <Link className="nav-link d-flex align-items-center position-relative contact-with-coins" to={path}>
                    <i className={`${icon} me-2 mt-3`} style={{ color: "#16a34a" }}></i>
                    {name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
